import { Appointment } from 'components/_temp_ui_common/Appointments/types';
import { useQuery } from 'react-query';

import { QueryKeys } from '../QueryKeys';
import { getAppointments, getAppointmentsParams } from './getAppointments';

export const useAppointments = (
  memberId?: string,
  params: getAppointmentsParams = {},
  requestType?: string,
) => {
  return useQuery<Appointment[]>(
    QueryKeys.appointments(memberId ?? '', params),
    () => getAppointments(memberId!, params, requestType),
    {
      enabled: !!memberId,
    },
  );
};
